
import { Button } from "@/components/ui/button";
import { Code, Settings, Search, Image as ImageIcon, ArrowRight } from "lucide-react";
import { useTranslatedText } from "@/hooks/useTranslate";
import { useNavigate } from "react-router-dom";

const ServicesSection = () => {
  const navigate = useNavigate();

  const titleText = useTranslatedText("Servicios");
  const subtitleText = useTranslatedText("Desde soluciones digitales hasta estrategias de marketing de próxima generación, estamos aquí para sincronizar tus objetivos con el poder de la tecnología.");
  const consultaText = useTranslatedText("Consulta");

  const service1Title = useTranslatedText("Apps Desktop y Mobile");
  const service1Desc = useTranslatedText("Diseñamos y desarrollamos aplicaciones desktop y mobile con la velocidad y eficacia que necesitas.");
  const service2Title = useTranslatedText("Identidad de marca");
  const service2Desc = useTranslatedText("Diseñamos y desarrollamos aplicaciones desktop y mobile con la velocidad y eficacia que necesitas.");
  const service3Title = useTranslatedText("Hosting");
  const service3Desc = useTranslatedText("Optimizamos tu presencia en línea con soluciones de alojamiento escalable y de alto rendimiento.");
  const verMasText = useTranslatedText("Ver más");

  const services = [
    { icon: <Code className="w-8 h-8" />, title: service1Title, description: service1Desc, onClick: () => navigate('/servicios') },
    { icon: <ImageIcon className="w-8 h-8" />, title: service2Title, description: service2Desc, onClick: () => navigate('/servicios') },
    { icon: <Settings className="w-8 h-8" />, title: service3Title, description: service3Desc, onClick: () => navigate('/servicios') },
    { icon: <Search className="w-8 h-8" />, title: verMasText, description: "", isMore: true, onClick: () => navigate('/servicios') },
  ];

  return (
    <section id="servicios" className="py-20 bg-techno-dark relative">
      {/* Divider top */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-techno-purple/40 to-transparent"></div>

      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-5xl font-bold text-techno-purple">{titleText}</h2>
              <p className="text-gray-300 text-lg leading-relaxed">{subtitleText}</p>
            </div>

            <Button
              onClick={() => navigate('/contacto')}
              className="bg-button-gradient hover:opacity-90 transition-opacity duration-300"
            >
              {consultaText}
            </Button>

            <div className="relative mt-12">
              <img
                src="https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=400&h=300&fit=crop"
                alt="Technology devices"
                className="rounded-2xl animate-float opacity-80"
              />
            </div>
          </div>

          {/* 3D Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {services.map((service, index) => (
              <div key={index} className="card-3d">
                <div
                  onClick={service.onClick}
                  className={`card-3d-inner rounded-2xl p-6 transition-all duration-300 group cursor-pointer ${
                    service.isMore
                      ? 'bg-gradient-to-br from-techno-purple to-techno-accent'
                      : 'glass-strong gradient-border hover:border-techno-purple/40'
                  } animate-fade-in`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="space-y-4">
                    <div className={`${service.isMore ? 'text-white' : 'text-techno-purple'} group-hover:scale-110 transition-transform duration-300`}>
                      {service.icon}
                    </div>
                    <h3 className="text-xl font-semibold text-white">{service.title}</h3>
                    {service.description && (
                      <p className={`${service.isMore ? 'text-white/90' : 'text-gray-400'} text-sm leading-relaxed`}>
                        {service.description}
                      </p>
                    )}
                    {service.isMore ? (
                      <div className="flex justify-end">
                        <ArrowRight className="w-6 h-6 text-white group-hover:translate-x-1 transition-transform" />
                      </div>
                    ) : (
                      <ArrowRight className="w-5 h-5 text-techno-purple opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-300" />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
